import React, { useState, useRef, useEffect } from 'react';
import * as xlsx from 'xlsx';
import Sidebar from '../Sidebar';
// import env from 'react-dotenv'
export default function PCGAInputPage() {
    const [prices, setPrices] = useState([]);
    const [prices2, setPrices2] = useState([])
    const [rowStart, setRowStart] = useState();
    const [rowEnd, setRowEnd] = useState();

//contains the ref
  const startRef= useRef(null)
  const endRef = useRef(null)
  const inpRef = useRef(null)

  //resetting after submit
  const reset =()=>{
    setPrices([])
    setPrices2([])
    setRowStart()
    setRowEnd()

    startRef.current.value=''
    endRef.current.value=''
    inpRef.current.value=''
  }


  useEffect(()=>{
      if(rowStart && rowEnd){
        const items = prices2.slice((rowStart-2), (rowEnd-1))
        setPrices(items)
      }
      else{
        setPrices(prices2)
      }
  },[prices2])


  useEffect(()=>{
    if(rowStart && rowEnd){
      const items = prices2.slice((rowStart-2), (rowEnd-1))
      setPrices(items)
    }
    else{
      setPrices(prices2)
    }
  },[rowStart, rowEnd])
  


  const readUploadFile = (e) => {
    e.preventDefault();
    if (e.target.files && e.target.files.length > 0) {
        const reader = new FileReader();
        reader.onload = (event) => {
            const data = event.target.result;
            try {
                const workbook = xlsx.read(data, { type: "array" });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const json = xlsx.utils.sheet_to_json(worksheet);

                const selectedRows = json.map(row => {
                    const cleanedRow = {};

                    // Define the fields you want to include in the output
                    const fieldsToInclude = [
                       'date',
                        'cropYear',
                        'district_id',
                        'S_No',
                        'nameOfDistrict',
                        'arrivalsInBales',
                        'pressingInBales',
                        'tcp',
                        'exporters',
                        'textiles',
                        'totalBalesSold',
                        'stockOfUnsoldBales',
                        'stockOfUnginnedBales',
                        'arrivalsAsOn',
                        'diffFromLastYearsArrivalsInBales',
                        'change',
                        'percentage',
                        'fortnightlyFlow',
                        'ftysOpr',
                    ];

                    // Iterate through the fields and include them if they have a value
                    for (const field of fieldsToInclude) {
                        if (row[field] !== undefined) {
                            if (field === 'date') {
                                cleanedRow[field] = xlsx.SSF.format('yyyy-mm-dd', new Date((row.date - 25569) * 86400 * 1000));
                            } else {
                                cleanedRow[field] = String(row[field]);
                            }
                        }
                    }

                    return cleanedRow;
                  // })
                })
                
                setPrices2(selectedRows)
                
            } catch (error) {
                console.error("Error processing file:", error);
            }
        };
        reader.readAsArrayBuffer(e.target.files[0]);
    }
}






    const handleSubmit = async (e) => {
        e.preventDefault();
        // Handle form submission here
        const token = sessionStorage.getItem('token')
        const response = await fetch(`${process.env.REACT_APP_API_URL}/create-PCGA`, {
            method:"POST",
            headers:{
                "Content-Type":"application/json",
                'x-access-token':token
            },
            body: JSON.stringify(prices)
        })
        // .then(console.log("Successfully submitted!")).then(reset())
    }

    return (
<>

<div className="sidebar">
      <Sidebar/>
      </div>
        <div id='tabler'>
            <form onSubmit={handleSubmit}>
            <h3 style={{paddingTop:"20px", paddingBottom:"20px"}}>PCGA File Upload</h3>
            <div className='excel-upload-note'>
            <ol><p>Both <strong>Start Row</strong> and <strong>End Row</strong> are required to select specific rows of the excel sheet.</p>
            </ol>
            </div>


<div style={{ display: 'flex', justifyContent: 'space-around' }}>
  <div class="input-group mb-3" style={{ marginRight: '10px' }}>
  <span class="input-group-text" id="inputGroup-sizing-default">Start Row</span>
    <input type="text" class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-default" onChange={(e) => setRowStart(e.target.value)} ref={startRef} required/>
  </div>

  <div class="input-group mb-3" style={{ marginLeft: '10px' }}>
    <span class="input-group-text" id="inputGroup-sizing-default">End Row</span>
    <input type="text" class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-default" onChange={(e) => setRowEnd(e.target.value)} ref={endRef} required/>
  </div>
</div>



<div class="mb-3">
  {/* <label for="formFile" class="form-label">Upload file</label> */}
  <input class="form-control" type="file" id="upload" name='upload' onChange={readUploadFile} ref={inpRef}/>
</div>


            <br />
            
            <button type="button" onClick={handleSubmit}class="btn submit-btn">Submit</button>
        </form>

        <table class="table" id="table1">

<thead>
  <tr>
    
    {/* <th scope="col">Price_id</th> */}
    <th scope='col'>Date</th>
    <th scope="col" >Crop Year</th>
    <th scope="col">District</th>
    <th scope="col">Arrivals (Bales)</th>
    <th scope="col">Pressing (Bales)</th>
    <th scope="col">Exporter</th>
    <th scope="col">Textile</th>
    <th scope="col">Total Sold</th>
    <th scope="col">Unsold Bales</th>
    <th scope="col">Unginned Bales</th>
  </tr>
</thead>

<tbody>

    {prices && prices.map((price, index) =>(
          <tr key={price._id}>
              <th scope="row">{new Date(price.date).toLocaleDateString('en-US')}</th>
              {/* <th>{price._id}</th> */}
              <td>{price.cropYear}</td>
              <td>{price.nameOfDistrict}</td>
              <td>{price.arrivalsInBales}</td>
              <td>{price.pressingInBales}</td>
              <td>{price.exporters}</td>
              <td>{price.textiles}</td>
              <td>{price.totalBalesSold}</td>
              <td>{price.stockOfUnsoldBales}</td>
              <td>{price.stockOfUnginnedBales}</td>
          </tr>
    ))}
</tbody>

</table>
        </div>
</>
    );
}
